<template>
  <div>
    <b-row>
      <b-col md="2" class="float-left">
        <b-form-group label="Période" label-for="filtre-term">
          <b-form-select id="filtre-term" v-model="searchTerm" :options="optionsSearchTerm"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-overlay :show="showLoading" no-wrap />
    <vue-good-table
      :columns="columnsDocuments"
      :rows="rowsDocuments"
      :rtl="direction"
      style-class="vgt-table condensed"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: pageLength,
        rowsPerPageLabel: '',
        dropdownAllowAll: false,
        perPageDropdownEnabled: false,
        nextLabel: 'Suivant',
        prevLabel: 'Précédent',
        ofLabel: 'de',
        infoFn: params => ``
      }"
      :select-options="{
            enabled: true,
            selectOnCheckboxOnly: true,
            selectionInfoClass: 'custom-class',
            selectionText: 'lignes sélectionnées',
            clearSelectionText: 'Effacer la sélection',
            disableSelectInfo: false,
            selectAllByGroup: false
          }"
      @on-selected-rows-change="selectionChanged"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Action -->
        <span v-if="props.column.field === 'actions'">
          <span>
            <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
              <template v-slot:button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
              </template>
              <b-dropdown-item v-if="can('Visualize document user')" @click="displayDocument(props.row.id, props.row.Name, props.row.NomDuDocument)">
                <feather-icon icon="SearchIcon" class="mr-50" />
                <span>Visualiser</span>
              </b-dropdown-item>
              <b-dropdown-item v-if="can('Delete document user')" @click="deleteDocument(props.row, props.row.vgt_id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Supprimer</span>
              </b-dropdown-item>
              <b-dropdown-item v-if="can('Historize compliance') && props.row.etat === 'Actif' && props.row.document_conformite == 'is_doc_confirmite'"
                               @click="historiserDocumentConformite(props.row.courtierDocumentId, props.row.vgt_id)"
              >
                <feather-icon class="mr-50" icon="ClockIcon"/>
                <span>Historiser</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
      </template>
      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <b-row class="mt-2 align-items-center">
              <b-col md="6" lg="5" xxl="3">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap ">
                    Affichage 1 à
                  </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['3','5','10']"
                    class="mx-1"
                    @input="(value)=>props.perPageChanged({currentPerPage:value})"
                  />
                  <span class="text-nowrap"> de {{ props.total }} entrées </span>
                </div>
              </b-col>
          </b-row>
        <b-row class="mt-2 align-items-center">
          <b-col md="4">
            <b-input-group>
              <b-form-select v-model="selected" :options="options" />
              <b-input-group-append>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                  @click="action_masse(selected)">
                  <span>Valider </span>
                  <feather-icon icon="ArrowRightIcon" class="mr-50" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col>
            <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </template>
      <div slot="emptystate" class="text-center align-middle">
        <span>Aucune donn&eacute;e disponible dans le tableau</span>
      </div>
    </vue-good-table>

    <b-modal id="modal-display-document" ref="modal-display-document" :title="document.name" cancel-title="Fermer" ok-title="Télécharger" cancel-variant="outline-secondary" @ok="downloadDocument(document.base64, document.nameToDownload)">
      <form ref="form">
        <b-img v-if="document.extensionDocument === 'IMAGE'" :src="document.base64" fluid :alt="document.name" />
      </form>
    </b-modal>
  </div>
</template>

<script>
import { BPagination, BFormGroup, BFormSelect, BDropdown, BDropdownItem, BRow, BCol, BButton, BInputGroup, BInputGroupAppend, BOverlay, BModal, BImg, VBToggle } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import { VueGoodTable } from 'vue-good-table'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    BModal,
    BImg,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContentVue
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple
  },
  props: {
    documentUserData: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
      required: true
    }
  },
  data() {
    return {
      searchTerm: 'Actif',
      optionsSearchTerm: [
        {
          value: 'Actif',
          text: 'En cours'
        },
        {
          value: 'Historique',
          text: 'Historique'
        }
      ],
      pageLength: 3,
      dir: false,
      columnsDocuments: [
        { label: 'Famille de document', field: 'FamilleDeDocument', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Type de document', field: 'TypeDeDocument', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Nom du document', field: 'NomDuDocument', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        // { label: 'Description', field: 'Description', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: "Date de l'ajout", field: 'CreeLe', type: 'date', dateInputFormat: 'dd/MM/yyyy', dateOutputFormat: 'dd/MM/yyyy', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { field: 'actions', label: 'Actions', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' }
      ],
      rowsDocuments: [],
      rowsDocumentsKeep: [],
      document: {
        base64: null,
        name: null,
        nameToDownload: null,
        extensionDocument: null
      },
      showLoading: false,
      selectedrows_masse: [],
      selected: null,
      options: [
        { value: null, text: 'Action de masse' },
        { value: 'Supprimer', text: ' Supprimer ' }
      ],
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    }
  },
  watch: {
    documentUserData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.rowsDocumentsKeep = val
        this.rowsDocuments = this.rowsDocumentsKeep.filter(item => item.etat === this.searchTerm)
      }
    },
    searchTerm() {
      this.filterData()
    }
  },
  mounted() {
    this.showLoading = false
  },
  methods: {
    selectionChanged(params) {
      this.selectedrows_masse = params
    },
    messageToast(text, title, variant) {
      this.$toast({
        component: ToastificationContentVue,
        props: {
          title,
          icon: 'BellIcon',
          text,
          variant
        }
      })
    },
    downloadDocument(base64, name) {
      if (base64) {
        const a = document.createElement('a')
        a.href = base64
        a.download = name
        a.click()
        this.messageToast('Le document a été téléchargé avec succès.', 'Succès', 'success')
      } else {
        this.messageToast('Aucun document trouvé à télécharger, veuillez essayer de le télécharger après.', 'Erreur', 'warning')
      }
    },
    clearDocumentDisplay() {
      this.document.base64 = null
      this.document.name = null
      this.document.nameToDownload = null
      this.document.extensionDocument = null
    },
    displayDocument(id, name, NomDuDocument) {
      this.$http
        .get(`/document/generate_base64_for_document/${id}`)
        .then(res => {
          if (res.data.success) {
            this.clearDocumentDisplay()
            if (res.data.data.isDownload) {
              this.downloadDocument(res.data.data.base64, name)
            } else if (!res.data.data.isDownload && res.data.data.extensionDocument === 'IMAGE') {
              this.document.base64 = res.data.data.base64
              this.document.name = NomDuDocument || name
              this.document.nameToDownload = name
              this.document.extensionDocument = res.data.data.extensionDocument
              this.$refs['modal-display-document'].show()
            } else if (!res.data.data.isDownload && res.data.data.extensionDocument === 'PDF') {
              // const pdfWindow = window.open('')
              // pdfWindow.document.write(`<iframe width='100%' height='100%' src='${res.data.data.base64}' />`)
              this.downloadDocument(res.data.data.base64, name)
            }
          } else {
            this.clearDocumentDisplay()
            this.messageToast(res.data.message, 'Erreur', 'error')
          }
        })
        .catch(err => {
          this.clearDocumentDisplay()
          this.messageToast(err.response.data.errors[0], 'Erreur', 'error')
          console.error(err)
        })
    },
    deleteDocument(document, vgtId) {
      var id=document.id
      this.$swal({
        title: 'Etes-vous sûr de vouloir supprimer le document ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then(confirmed => {
        if (confirmed.value) {
          this.showLoading = true
          this.$http
            .delete(`/document/delete_document_courtier/${id}`)
            .then(res => {
              if (res.data.success) {
                const indexDocument = this.rowsDocuments.findIndex(item => item.id === id)
                this.$emit('set-statut-document',document);
                this.rowsDocuments.splice(indexDocument, 1)
                this.messageToast(res.data.message, 'Succès', 'success')
              } else {
                this.messageToast(res.data.message, 'Erreur', 'error')
              }
              this.showLoading = false
            })
            .catch(error => {
              this.showLoading = true
              this.messageToast(error.response.data.errors[0], 'Erreur', 'error')
            })
        }
      })
    },
    action_masse(action) {
      switch (action) {
        case 'Supprimer':
          if (this.selectedrows_masse.selectedRows.length > 0) {
            this.$swal({
              title: 'Êtes-vous sûr de vouloir supprimer les documents ?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Oui',
              cancelButtonText: 'Non',
              customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
              },
              buttonsStyling: false,
            })
                .then((result) => {
                  if (result.value) {
                    const selected_doc = [];
                    for (let i = 0; i < this.selectedrows_masse.selectedRows.length; i++) {
                        selected_doc.push(this.selectedrows_masse.selectedRows[i].id)
                    }
                    this.$http
                        .post('document/deleteDocumentCourtierMasse/', { 'documents': selected_doc })
                        .then((res) => {
                          if (res.data.success) {
                            for (let i = 0; i < this.selectedrows_masse.selectedRows.length; i++) {
                              const indexDocument = this.rowsDocuments.findIndex(item => item.id === this.selectedrows_masse.selectedRows[i].id)
                              this.rowsDocuments.splice(indexDocument, 1)
                              const indexDocumentKeep = this.rowsDocumentsKeep.findIndex(item => item.id === this.selectedrows_masse.selectedRows[i].id)
                              this.rowsDocuments.splice(indexDocumentKeep, 1)
                              this.$emit('set-statut-document',this.selectedrows_masse.selectedRows[i]);
                            }
                          }
                        })
                        .catch((err) => {
                        })

                    this.$swal({
                      icon: 'success',
                      title: 'Supprimé!',
                      customClass: {
                        confirmButton: 'btn btn-success',
                      },
                    })
                  }
                })
          }
          break
          default:

      }
    },
    historiserDocumentConformite(documentCourtierId, vgtId) {
      this.$swal({
        title: 'Etes-vous sûr de vouloir historiser le document?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      })
          .then(confirmed => {
            if (confirmed.value) {
              this.$http
                  .put(`/document/historiserDocumentConformite/${documentCourtierId}`)
                  .then(res => {
                    if (res.data.success) {
                      const indexDocument = this.rowsDocuments.findIndex(item => item.courtierDocumentId === documentCourtierId)
                      this.rowsDocuments[indexDocument].etat = 'Historique'
                      const indexDocumentKeep = this.rowsDocumentsKeep.findIndex(item => item.courtierDocumentId === documentCourtierId)
                      this.rowsDocumentsKeep[indexDocumentKeep].etat = 'Historique'
                      this.filterData();
                      this.messageToast(res.data.message, 'Succès', 'success')
                    } else {
                      this.messageToast(res.data.message, 'Erreur', 'error')
                    }
                  })
                  .catch(error => {
                    console.log(error)
                    this.messageToast(error.response.data, 'Erreur', 'error')
                  })
            }
          })
    },
    resetFilter() {
      this.searchTerm = 'Actif'
    },
    filterData() {
      this.rowsDocuments = this.rowsDocumentsKeep
      if (this.searchTerm) this.rowsDocuments = this.rowsDocuments.filter(item => item.etat === this.searchTerm)
    },
  }
}
</script>

<style></style>
